import './App.scss';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./components/Main";
import PythonAuditSection from "./components/PythonAuditSection/PythonAuditSection";
import PrivacyPolicySection from "./components/ContactSection/PrivacyPolicySection";
import CookiePolicySection from "./components/CookiesSection/CookiePolicySection";

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/python-audit" element={<PythonAuditSection/>}/>
          <Route path="/design" element={<></>}/>
          <Route path="/privacy-policy" element={<PrivacyPolicySection/>}/>
          <Route path="/cookie-policy" element={<CookiePolicySection/>}/>
        </Routes>
      </BrowserRouter>
  );
}

export default App;
